<kendo-listview class="email-list" [data]="openEmailWindows$ | async">
   <ng-template kendoListViewItemTemplate let-dataItem="dataItem">
      <samweb-email-list-item [messageId]="dataItem"> </samweb-email-list-item>
   </ng-template>
</kendo-listview>
